/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type AccountingIntegrationLogDto = {
    id: number;
    therapistId: number;
    providerType: AccountingIntegrationLogDto.providerType;
    /**
     * HTTP status code of the failed request
     */
    statusCode: number;
    /**
     * HTTP status text
     */
    statusText?: string | null;
    /**
     * API endpoint that was called
     */
    endpoint: string;
    /**
     * HTTP method used
     */
    httpMethod: string;
    /**
     * Error response body from the API
     */
    errorBody?: string | null;
    /**
     * Human-readable operation description
     */
    operation: string;
    /**
     * Additional context about the error
     */
    context?: Record<string, any>;
    /**
     * Whether the log has been read/acknowledged
     */
    isRead: boolean;
    /**
     * When the log was marked as read
     */
    readAt?: string | null;
    createdAt: string;
};
export namespace AccountingIntegrationLogDto {
    export enum providerType {
        LEXOFFICE = 'lexoffice',
        SEVDESK = 'sevdesk',
        TEBUTO = 'tebuto',
    }
}

